<template>
    <div class="shipment-address">
        <h5 class="shipment-address__item">From: {{addressFrom}}</h5>
        <h5 class="shipment-address__item">To: {{addressTo}}</h5>
    </div>
</template>
<script>
    import {mapGetters} from "vuex";
    import {convertObjToAddress} from "@/lib/lib";

    export default {
        name: 'ShipmentList_address',
        props: {
            shipmentId: [String, Number],
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters([
                'getShipmentsById',
                "isShipmentsFullLoad",
                "getShipmentsFullLoadById",
            ]),
            isShipmentFullLoad() {
                return this.isShipmentsFullLoad || this.getShipmentsFullLoadById[this.shipmentId]
            },
            shipment() {
                return this.getShipmentsById[this.shipmentId]
            },
            routes() {
                return this.shipment?.routes || []
            },
            addressFrom() {
                if(!this.isShipmentFullLoad) return '-'
                let route = this.routes?.find(r => r.stop_order == 0)
                let address = route?.address || {}
                let fullAddress = (!this.routeMeta?.isGuest || !route.address_name) ? ` (${address?.fullName || convertObjToAddress(address.address)})` : ''
                return (route?.address_name || '') + fullAddress
            },
            addressTo() {
                if(!this.isShipmentFullLoad) return '-'
                let route = this.routes?.find(r => r.stop_order == 1)
                let address = route?.address || {}
                let fullAddress = (!this.routeMeta?.isGuest || !route.address_name) ? ` (${address?.fullName || convertObjToAddress(address.address)})` : ''
                return (route?.address_name || '') + fullAddress
            },
        },
        updated: function() {
           // console.log(`UnitsList_unit_address ${this.unitLmsgLocation} updated`);
        },
    }
</script>
<style lang="scss" scoped>
.shipment-address {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr;
    overflow: hidden;

    &__item {
        @include font(11px, normal, 400, none, normal, var(--color-font-description));
        height: 100%;
        width: 100%;
        -webkit-line-clamp: 2; /* Число отображаемых строк */
        display: -webkit-box; /* Включаем флексбоксы */
        -webkit-box-orient: vertical; /* Вертикальная ориентация */
        overflow: hidden; /* Обрезаем всё за пределами блока */
        max-height: 30px;
    }
}
</style>